/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/job.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiJob } from './ApiJob';
import { ApiJobFromJSON, ApiJobFromJSONTyped, ApiJobToJSON, ApiJobToJSONTyped } from './ApiJob';

/**
 *
 * @export
 * @interface ApiListJobsResponse
 */
export interface ApiListJobsResponse {
  /**
   * A list of jobs returned.
   * @type {Array<ApiJob>}
   * @memberof ApiListJobsResponse
   */
  jobs?: Array<ApiJob>;
  /**
   * The total number of jobs for the given query.
   * @type {number}
   * @memberof ApiListJobsResponse
   */
  total_size?: number;
  /**
   * The token to list the next page of jobs.
   * @type {string}
   * @memberof ApiListJobsResponse
   */
  next_page_token?: string;
}

/**
 * Check if a given object implements the ApiListJobsResponse interface.
 */
export function instanceOfApiListJobsResponse(value: object): value is ApiListJobsResponse {
  return true;
}

export function ApiListJobsResponseFromJSON(json: any): ApiListJobsResponse {
  return ApiListJobsResponseFromJSONTyped(json, false);
}

export function ApiListJobsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiListJobsResponse {
  if (json == null) {
    return json;
  }
  return {
    jobs: json['jobs'] == null ? undefined : (json['jobs'] as Array<any>).map(ApiJobFromJSON),
    total_size: json['total_size'] == null ? undefined : json['total_size'],
    next_page_token: json['next_page_token'] == null ? undefined : json['next_page_token'],
  };
}

export function ApiListJobsResponseToJSON(json: any): ApiListJobsResponse {
  return ApiListJobsResponseToJSONTyped(json, false);
}

export function ApiListJobsResponseToJSONTyped(
  value?: ApiListJobsResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    jobs: value['jobs'] == null ? undefined : (value['jobs'] as Array<any>).map(ApiJobToJSON),
    total_size: value['total_size'],
    next_page_token: value['next_page_token'],
  };
}
